import BottomNavigation from "../../components/BottomNavigation";
import theme from "../../configs/theme-config";
import useNavigation from "../../hooks/useNavigation";
import { color as colorUtil } from "@sloth-system/styled-utils";
import { Box } from "digiwash-components";
import React, { useEffect } from "react";
import { ScrollView, Platform } from "react-native";

let nativeStyles = {
  extraSpace: {
    paddingBottom: 74,
  },
  scrollview: {
    flex: 1,
  },
  scrollviewLocked: {},
  container: { flex: 1 },
  constraints: {
    maxWidth: 768,
    marginRight: "auto",
    marginLeft: "auto",
    width: "100%",
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    position: "relative",
    top: -76,
    overflow: "hidden",
  },
};
const webStyles = {
  constraints: {
    maxWidth: 768,
    marginRight: "auto",
    marginLeft: "auto",
    width: "100%",
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    position: "relative",
    top: -76,
    overflow: "hidden",
  },
  scrollview: {
    // height: "100vh", // it makes it double scroll
    flex: 1,
    // react-native-modal adds some styles automatically
    overflow: "unset",
  },
  extraSpace: {
    paddingBottom: 74,
  },
  container: {
    flex: 1,
    height: "100%",
  },
};

let styles = Platform.OS === "web" ? webStyles : nativeStyles;

interface PageContainerProps {
  bg?: string;
  children?: React.ReactNode;
  beforeScrollView?: React.ReactNode;
  afterScrollView?: React.ReactNode;
  insideBeignScrollView?: React.ReactNode;
  insideEndScrollView?: React.ReactNode;
  extraSpaceFromBottom?: boolean; // only works with constraints & web
  showBottomNavigation?: boolean;
}

function PageContainer(props: PageContainerProps) {
  let constraintsContainerStyles: any[] = [styles.constraints];
  if (props.extraSpaceFromBottom) {
    constraintsContainerStyles.push(styles.extraSpace);
  }
  let scrollViewStyles: any[] = [styles.scrollview];
  let nav = useNavigation();

  React.useEffect(() => {
    if (Platform.OS === "android" && !props.showBottomNavigation) {
      nav.dangerouslyGetParent().setOptions({
        tabBarVisible: false,
      });
      return () => {
        nav.dangerouslyGetParent().setOptions({
          tabBarVisible: true,
        });
      };
    }
    return undefined;
  }, []);

  let bg = props.bg || "common.white";

  useEffect(() => {
    if (Platform.OS === "web") {
      document.body.style.backgroundColor = colorUtil(bg)({
        theme: theme,
      });
    }
    return () => {
      if (Platform.OS === "web") {
        document.body.style.backgroundColor = "";
      }
    };
  }, []);
  return (
    <Box bg={bg} style={styles.container}>
      {props.beforeScrollView}
      <ScrollView style={scrollViewStyles}>
        {props.insideBeignScrollView}
        {props.children ? (
          <Box bg={bg} style={constraintsContainerStyles}>
            {props.children}
          </Box>
        ) : null}

        {props.insideEndScrollView}
      </ScrollView>
      {props.afterScrollView}
      {props.showBottomNavigation && Platform.OS === "web" ? (
        <BottomNavigation />
      ) : null}
    </Box>
  );
}

export default PageContainer;
